import { useState } from 'react';
import { Boxes, LayoutDashboard, ShoppingCart, Wrench } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import { OverviewSub } from './OverviewSub';
import { VentasSub } from './VentasSub';
import { StockSub } from './StockSub';
import { MantenimientoSub } from './MantenimientoSub';

/**
 * Segmento Operativo del Dashboard (solo Argentina). Sub-botonera con cuatro
 * vistas: Overview (combinado), Ventas, Stock y Mantenimiento.
 */

const SUBS = [
  { id: 'overview', label: 'Overview', Icon: LayoutDashboard },
  { id: 'ventas', label: 'Ventas', Icon: ShoppingCart },
  { id: 'stock', label: 'Stock', Icon: Boxes },
  { id: 'mantenimiento', label: 'Mantenimiento', Icon: Wrench },
] as const;

type SubId = (typeof SUBS)[number]['id'];

export function OperativoSegment() {
  const [sub, setSub] = useState<SubId>('overview');

  // La sub-botonera se pasa a cada sub-vista y se renderiza a la IZQUIERDA de
  // su fila de controles (una sola fila, sin desperdiciar el espacio derecho).
  const nav = (
    <div className="flex flex-wrap items-center gap-2">
      <div
        className="inline-flex flex-wrap gap-1 rounded-lg border bg-card p-0.5 shadow-sm"
        role="tablist"
        aria-label="Vistas operativas"
      >
        {SUBS.map(({ id, label, Icon }) => (
          <button
            key={id}
            type="button"
            role="tab"
            aria-selected={sub === id}
            onClick={() => setSub(id)}
            className={cn(
              'flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium transition-colors',
              sub === id
                ? 'bg-foreground text-background'
                : 'text-muted-foreground hover:bg-muted',
            )}
          >
            <Icon className="h-4 w-4" aria-hidden />
            {label}
          </button>
        ))}
      </div>
      <span className="text-sm text-muted-foreground">· Argentina</span>
    </div>
  );

  return (
    <div className="flex flex-col gap-4">
      {sub === 'overview' ? (
        <OverviewSub nav={nav} />
      ) : sub === 'ventas' ? (
        <VentasSub nav={nav} />
      ) : sub === 'stock' ? (
        <StockSub nav={nav} />
      ) : (
        <MantenimientoSub nav={nav} />
      )}
    </div>
  );
}
